import { AILearningDashboard } from "@/components/ai/AILearningDashboard";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { LeadPrioritization } from "@/components/ai/LeadPrioritization";
import { AIDealForecast } from "@/components/ai/AIDealForecast";
import { useLeads } from "@/hooks/useLeads";

export default function AIInsights() {
  const { data: leads } = useLeads();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">AI Insights</h1>
        <p className="text-muted-foreground">
          AI-powered analytics, learning metrics, and optimization recommendations
        </p>
      </div>
      
      <Tabs defaultValue="learning" className="space-y-4">
        <TabsList>
          <TabsTrigger value="learning">AI Learning Loop</TabsTrigger>
          <TabsTrigger value="leads">Lead Prioritization</TabsTrigger>
          <TabsTrigger value="forecast">Deal Forecast</TabsTrigger>
        </TabsList>
        
        <TabsContent value="learning" className="space-y-4">
          <AILearningDashboard />
        </TabsContent>
        
        <TabsContent value="leads" className="space-y-4">
          <LeadPrioritization leads={leads || []} />
        </TabsContent>
        
        <TabsContent value="forecast" className="space-y-4">
          <AIDealForecast />
        </TabsContent>
      </Tabs>
    </div>
  );
}
